import React from "react";
import type { FoodSpot } from "../types";

const TYPE_ICON: Record<FoodSpot["type"], string> = {
  Restaurant: "fa-utensils",
  "Street Food": "fa-cart-shopping",
  Cafe: "fa-mug-saucer",
  Bakery: "fa-bread-slice",
  Beverages: "fa-mug-hot",
  "Beach Shack": "fa-umbrella-beach",
};

interface Props {
  spot: FoodSpot;
  onSelect: (spot: FoodSpot) => void;
}

const SpotCard: React.FC<Props> = ({ spot, onSelect }) => {
  return (
    <button
      className="spot-card"
      onClick={() => onSelect(spot)}
      aria-label={`Open details for ${spot.name}`}
    >
      <div className="spot-card__top">
        <span className="spot-card__type">
          <i className={"fa-solid " + TYPE_ICON[spot.type]} aria-hidden="true" />
          {spot.type}
        </span>
        <span className="spot-card__rating">
          <i className="fa-solid fa-star" aria-hidden="true" />
          {spot.rating.toFixed(1)}
        </span>
      </div>
      <h3 className="spot-card__name">{spot.name}</h3>
      <span className="spot-card__area">
        <i className="fa-solid fa-location-dot" aria-hidden="true" />
        {spot.area} &middot; {spot.cuisine}
      </span>
      <p className="spot-card__desc">{spot.description}</p>
      <div className="spot-card__specs">
        {spot.specialties.slice(0, 3).map((s) => (
          <span key={s} className="spec-tag">
            {s}
          </span>
        ))}
      </div>
      <div className="spot-card__bottom">
        <span className="spot-card__price">{spot.priceRange}</span>
        <span className="spot-card__cta">
          View
          <i className="fa-solid fa-arrow-right" aria-hidden="true" />
        </span>
      </div>
    </button>
  );
};

export default SpotCard;